// reflects what we get from config
export const ADULT = 0;
export const CHILD = 1;
export const INFANT = 2;

export default { ADULT, CHILD, INFANT };
